import { render, staticRenderFns } from "./appearance.page.vue?vue&type=template&id=26199518&scoped=true&"
import script from "./appearance.page.vue?vue&type=script&lang=js&"
export * from "./appearance.page.vue?vue&type=script&lang=js&"
import style0 from "./appearance.page.vue?vue&type=style&index=0&id=26199518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26199518",
  null
  
)

export default component.exports